export interface NavItem {
  label: string;
  icon: string;
  path: string;
}

export const dashboardNavItems: NavItem[] = [
  { label: 'الرئيسية', icon: 'ri-dashboard-3-line', path: '/dashboard' },
  { label: 'الطلبات', icon: 'ri-file-list-3-line', path: '/orders' },
  { label: 'القطع والخدمات', icon: 'ri-shirt-line', path: '/items' },
  { label: 'الباقات', icon: 'ri-box-3-line', path: '/packages' },
  { label: 'المندوبين', icon: 'ri-e-bike-2-line', path: '/drivers' },
  { label: 'المعاملات المالية', icon: 'ri-wallet-3-line', path: '/finance' },
  { label: 'التقييمات', icon: 'ri-star-line', path: '/ratings' },
  { label: 'الإشعارات', icon: 'ri-notification-3-line', path: '/notifications' },
  { label: 'الإعدادات', icon: 'ri-settings-3-line', path: '/settings' },
];